<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" lg="6" md="12">
        <v-card class="productdetailscard">
          <v-card-title class="mt-0 py-0"> Shop </v-card-title>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="12" lg="8" md="12" class="px-0 pt-1 d-flex">
                <v-combobox
                  hide-details="auto"
                  hide-no-data
                  v-model="selectedShop"
                  @change="searchShops = ''"
                  :items="ShopsData"
                  clearable
                  :search-input.sync="searchShops"
                  outlined
                  item-text="name"
                  item-value="id"
                  label="Select Shop"
                  multiple
                  small-chips
                >
                </v-combobox>
                <v-btn
                  depressed
                  small
                  height="32"
                  class="btn_blue w-100 ml-2"
                  :disabled="!selectedShop || selectedShop.length === 0"
                  @click="AssignShopToProduct()"
                >
                  update
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                <v-row
                  class="pt-0"
                  v-for="productshop in ProdctShopsData"
                  :key="productshop"
                >
                  <v-col
                    cols="8"
                    sm="12"
                    md="8"
                    lg="8"
                    class="pr-5pt-1.5 pb-1 textbold"
                  >
                    {{ productshop.name }}
                    <v-tooltip top color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          @mouseenter="shopDetails(productshop)"
                          >mdi-alert-circle</v-icon
                        >
                      </template>
                      <h5>{{ shopshortname }}</h5>
                    </v-tooltip>
                  </v-col>

                  <v-col
                    cols="3"
                    sm="12"
                    md="3"
                    lg="3"
                    style="text-align: left"
                  >
                    <!-- <span class="statustext pr-5" >Payment Type</span> -->
                    <v-chip
                      :color="getStatusColor(productshop.is_active)"
                      label
                      style="
                        background-color: #c11e65;
                        color: white;
                        font-variant-caps: all-small-caps;
                        font-weight: bold;
                      "
                    >
                      {{
                        productshop.is_active == true ? 'Active' : 'Archieve'
                      }}
                    </v-chip></v-col
                  >
                  <v-col
                    cols="1"
                    sm="12"
                    md="1"
                    lg="1"
                    class="pr-3 pt-1.5 pb-2"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="red"
                          class="mr-2 pb-0"
                          @click="openConfirmation(productshop)"
                        >
                          mdi-archive
                        </v-icon>
                      </template>
                      <span>Remove</span>
                    </v-tooltip>
                  </v-col>
                </v-row>

                <paginationComponent
                  @paginationOptions="setPaginationOptions"
                  :url="`${module}/${$route.params.id}/shops`"
                  @response="receiveShopsResponse"
                  ref="shopdetails"
                  :paginationAction="false"
                  :filter="filter"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" sm="12" lg="6" md="12">
        <ProductSupplier :module="'products'" :id="Product.id" />
      </v-col>
    </v-row>
    <!-- </v-container> -->
  </div>
</template>
<script>
import { Product } from '../../../models/Product';
import ProductSupplier from './ProductSupplierComponent';
import _ from 'lodash';
import { SupplierListViewModel } from '@/models/View Models/Supplier';
import confirmation from '../../shared/components/confirmation';
import TableFilters from '@/components/base/TableFilters';
import paginationComponent from '../../shared/components/pagination.vue';
import { ProductViewModel } from '../../../models/View Models/ProductViewModel';

export default {
  data: () => ({
    Product: new Product(),
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    shopshortname: '',
    inheritAttrs: false,
    paginationOptions: {},
    searchShops: null,
    selectedShop: [],
    ShopsData: [],

    columns: [
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Status',
        value: 'status',
        show: true,
        disabled: false,
        align: 'center',
      },

      {
        text: 'Actions',
        value: 'action',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    filter: {
      search: '',
    },
    date_range: [],
    ProdctShopsData: [],
    productDetails: [],
  }),
  props: {
    module: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: '',
    },
  },
  components: { paginationComponent, TableFilters, ProductSupplier },
  created() {
    this.GetProductDetails();
  },
  computed: {
    dateRangeText() {
      this.filter.start = this.date_range[0];
      this.filter.end = this.date_range[1];
      return this.date_range.join(' ~ ');
    },
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  watch: {
    searchShops(value) {
      if (value == null) {
        return;
      }
      // if (!value) {
      //   this.GetShops("");
      // }
      this.GetShops(value);
    },
  },

  methods: {
    shopDetails(shop) {
      this.shopshortname = shop.sortform;
    },
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },
    refreshData() {
      this.$refs.shopdetails.refreshData();
    },
    async AssignShopToProduct() {
      let credentials = new Object();
      credentials.shops = [];
      this.selectedShop.map((p) => {
        credentials.shops.push(p.id);
      });
      credentials.productId = this.$route.params.id;
      this.AssignProduct(credentials);
    },
    AssignProduct(credentials) {
      this.$store
        .dispatch(`product/AssignShopToProducts`, credentials)
        .then((res) => {
          this.refreshData();
          this.selectedShop = null;
          this.isLoading = false;
          this.$toast.success('Shop assigned successfully');
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to assign shop');

          //   this.payment = new Payment();
        });
    },
    openConfirmation(item) {
      confirmation.dialog = true;

      this.$confirm('Do you want to Remove ?').then((res) => {
        if (res) {
          this.removeShop(item);
        }
      });
    },
    async removeShop(item) {
      const credentials = new Object();
      credentials.shops = [item.id];
      credentials.productId = this.$route.params.id;

      this.removeShopFromProduct(credentials);
    },

    removeShopFromProduct(credentials) {
      this.$store
        .dispatch(`product/RemoveShopFromProduct`, credentials)
        .then((res) => {
          this.refreshData();
          if (this.ProdctShopsData) {
            let index = this.ProdctShopsData.findIndex(
              (p) => p.id == credentials.shops[0],
            );
            if (index != -1) {
              this.ProdctShopsData.splice(index, 1);
            }
          }
          this.$toast.success('Shop removed successfully');
          this.selectedShop = [];
          this.GetShops();

          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast.error('Failed to remove shop.');
          //   this.payment = new Payment();
        });
    },
    GetProductDetails() {
      let productId = this.id;
      this.$store
        .dispatch('product/GetProductById', productId)
        .then((res) => {
          this.Product = res.data;
          this.productDetails = new ProductViewModel(res.data);

          this.productUnits = this.productDetails.units;
        })
        .catch((err) => {
          this.messages.push(err.data.title);
        });
    },
    getStatusColor(status) {
      return status == true ? 'green' : 'gray';
    },
    receiveShopsResponse(data) {
      this.ProdctShopsData = data;
      this.GetShops();
    },

    GetShops(query = '') {
      this.searchShops = null;
      let except = [];
      this.ProdctShopsData.forEach((shop) => {
        except.push(shop.id);
      });
      if (this.selectedShop && this.selectedShop.length > 0) {
        this.selectedShop.forEach((shop) => {
          except.push(shop.id);
        });
      }
      this.$store
        .dispatch('shop/GetShop', {
          query: query,
          except: except,
          status: 'active',
        })
        .then((res) => {
          this.ShopsData = res;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },
};
</script>

<style scoped>
.productdetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.textbold {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: left;

  color: #000000;
}
</style>
